export default __webpack_public_path__ + "static/media/imgbienvenido.73c1bd8e.jpg";